import {createReducer} from '@reduxjs/toolkit'
import {setEnvironment} from '../actions/environment'

export interface EnvironmentState {
  locale: string
  visitorId: string
  instanceId: string
  metaSiteId: string
}

const initialState: EnvironmentState = {
  locale: null,
  visitorId: null,
  instanceId: null,
  metaSiteId: null,
}

export const environment = createReducer(initialState, builder =>
  builder.addCase(setEnvironment, (state, action) => action.payload),
)
